// THE PMREM GENERATOR FOR THE RENDERER THAT IS ACTUALLY MOUNTED.
//
// `THREE.PMREMGenerator` — the one in three's core — prefilters by rendering
// four raw `ShaderMaterial` passes over a cube target. A node renderer compiles
// none of them, and the way it fails is the worst kind: the generator still
// ALLOCATES its render target and still hands back a texture of exactly the
// right size and mapping, so every downstream check passes. The cube is just
// empty. `scene.environment` is set, `material.envMap` is set, the binding
// report is clean, and the avatar is lit by nothing.
//
// MEASURED on myra in Startup_Level, against the same build on the classic
// renderer: with ambient and sun both at 0 the avatar is lit by exactly two
// things, the baked SH LightProbe and this IBL. On the node path, zeroing the
// probe rendered her face pure BLACK and zeroing `envMapIntensity` on every
// material changed nothing at all — so the IBL was contributing zero. Her
// forehead read 171,121,90 on the classic renderer and 68,38,24 on the node one,
// about a third of the light. The only console evidence was one line,
// `THREE.NodeBuilder: Material "ShaderMaterial" is not compatible`, which is
// easy to read as belonging to something else entirely.
//
// `three/webgpu` ships its own node-based `PMREMGenerator` with the same surface
// (`fromEquirectangular`, `compileEquirectangularShader`, `fromScene`,
// `dispose`), so this is a constructor swap and nothing else.

/**
 * @param {object} renderer  the live renderer
 * @returns {Promise<object>} a PMREM generator that can actually run on it
 */
export async function createPMREMGenerator(renderer) {
  // Through the app's OWN module: `three/webgpu` is named in exactly one place so
  // Vite's prebundle list and the imports stay in step.
  const { WGPU } = await import('../ogs/render/three/threeSplatDeps.js')
  return new WGPU.PMREMGenerator(renderer)
}
